import { call, select, takeEvery, put, all, delay } from 'redux-saga/effects';
import {
  editUserProfile,
  editUserProfileSuccess,
  editUserProfileFailure,
  getProfileById,
  getProfileByIdSuccess,
  getProfileByIdFailure,
} from '../../actions/EditProfile';
import {
  setProfileMonitoring,
  setProfileMonitoringSuccess,
} from '../../actions/ProfileList';
import {
  editProfileRequest,
  getProfileRequest,
  profileMonitoring,
} from '../../../api/requests/EditProfile/getProfileRequest';
import showSuccessWindow from '../../../../../common/components/successPopup/successPopup';
import { uploadAvatar } from '../../actions/Avatar/uploadAvatarActions';
import { avatarUploadRequest } from '../../../api/requests/EditProfile/avatarUploadRequest';
import { restoreLogin } from '../../actions/RestoreLogin';
import { showAlert } from '../../../../../common/redux/actions/alert';

import history from '../../../../../common/history';
import * as URLs from '../../../../../common/constants/systemUrls';
import { successEditProfile } from '../../../components/EditProfileForm/success';

const getFullName = data => {
  return (
    `${data.lastname} ${data.name}` +
    (data.patronymic ? ` ${data.patronymic}` : '')
  );
};

const getUserRole = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.roleId
  );
};

function* editProfile(action) {
  let roleId = yield select(getUserRole);
  try {
    const { payload } = action;
    const response = yield call(editProfileRequest, payload, roleId && roleId);
    if (response.data) {
      yield put(editUserProfileSuccess(response));
      showSuccessWindow(successEditProfile(getFullName(response.data.userId)));
      yield delay(1000);
      history.push('/' + URLs.AUTHORIZATION + '/' + URLs.PROFILES_LIST);
    } else {
      throw response;
    }
  } catch (e) {
    yield all([put(showAlert(e)), put(editUserProfileFailure(e))]);
  }
}

function* monitoringSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(profileMonitoring, payload);
    if (response.data.length) {
      yield put(setProfileMonitoringSuccess(response.data));
    }
  } catch (e) {
    yield put(editUserProfileFailure(e));
  }
}

function* getProfileSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProfileRequest, payload);
    yield put(getProfileByIdSuccess(response.data));
  } catch (e) {
    yield put(getProfileByIdFailure(e));
  }
}
function* uploadAvatarSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(avatarUploadRequest, payload);

    if (response.data.code === 200) {
      const localStorage = window.localStorage;
      const user = JSON.parse(localStorage.user);
      if (user) {
        user.info.photo = response.data.url;
      }
      localStorage.setItem('user', JSON.stringify(user));
    }
    yield put(restoreLogin());
  } catch (e) {}
}
export function* editProfileWatcher() {
  yield takeEvery(getProfileById.toString(), getProfileSaga);
  yield takeEvery(editUserProfile.toString(), editProfile);
  yield takeEvery(setProfileMonitoring.toString(), monitoringSaga);
  yield takeEvery(uploadAvatar.toString(), uploadAvatarSaga);
}
